import { KsService, useApiClient } from '@siclop/kstone-vue'
import type { NonWorkingDay } from '../models'

/**
 * Jours non travaillés de l'entreprise (ponts, fériés locaux…). Les fériés légaux ne se saisissent pas : l'API les
 * calcule (KStone) et les renvoie avec les jours d'entreprise par `getCalendar`.
 */
export class PublicHolidayService extends KsService {
  protected static mainUrl = '/public-holidays'

  /** Tous les jours non travaillés d'une année (fériés légaux + jours d'entreprise), triés par date. */
  static async getCalendar(year: number): Promise<NonWorkingDay[]> {
    return (await useApiClient().get<NonWorkingDay[]>(`${this.mainUrl}/calendar/${year}`)) ?? []
  }
}
